import React, { useState, useContext, useEffect, Fragment } from "react";
import PropTypes from "prop-types";
import Assignee from "components/sales/formSection/assignee/assignee";
import Layout from "components/sales/layout/layout";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import { Button } from "react-bootstrap";
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import Commercial from "components/sales/formSection/commercial/commercial";
import { documentUploadUrl } from "../../../services/redux/fileUpload/action";
import FormSection from "../../../components/sales/formSection/formSectionNew";
import AgreementContract from "../../../components/sales/formSection/agreementContract/agreementContract";
import DivLayout from "../../../components/sales/divLayout/divLayout";
import DocumentView from "../../../components/sales/downloadDocView/documentView";
import Milestone from "../../../components/sales/formSection/mileStone/mileStone";
import InvoiceModuleRenew from "components/sales/formSection/materialHardware/invoiceModuleRenew";
import { toast } from "react-toastify";
import { handleValidateObj } from "constants/objValues/objvalues";
import TableSection from "components/sales/tableSection/tableSection";
import { useHistory } from "react-router-dom";
import Increament from 'components/sales/formSection/materialHardware/increament';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';

const RenewContract = ({
  documentUploadUrl,
  documentUrlData,
  getContractDataForRenewal,
  contractData,
  match,
  renewalSaveData,
  renewalSaveResp,
  fetchInvoiceDetails,
  getInvoiceData = [],
  getSearchUser,
  ownershipUserSuggestions = [],
}) => {
  const [isFiled, setIsFiled] = useState(false);
  const [siteId, setsiteId] = useState();
  const [isModal, setIsModal] = useState(false);
  const [isRequired, setRequired] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [products, setProducts] = useState("");
  const { baseUrl } = useContext(BaseUrl);
  const postDataInputs = {
    commercial: null,
    agreementDtls: null,
    invoiceModuleData: null,
  };
  const inputs = {
    assigneeDetail: null,
  };
  const [assigneeData, setAssigneeData] = useState(inputs);
  const [postCorporateData, setPostCorporateData] = useState(postDataInputs);
  const [showAgreementDetails, setShowAgreementDetails] = useState(false);
  const [agreementLength, setAgreementLength] = useState(null);
  const [existingPostsaleData, setExistingPostsaleData] = useState(null);
  const [confirmInvoices, setConfirmInvoices] = useState(false);
  const [invoiceModal, setInvoiceModal] = useState(false);
  const [listData, setListData] = useState([]);
  const [scheduleType, setScheduleType] = useState();
  const [commercialData, setCommercialData] = useState({
    commercialData:null,
  });
  const [incrementData, setIncrementData] = useState({
    increment_type:null,
    duration:null,
    increament_amount:null,
    inc:null,
  });
  const [contractPriceToEndClient, setContractPriceToEndClient] = useState(null);
  const [ownershipUserId, setOwnershipUserId] = useState(null);
  const [ownershipSearchText, setOwnershipSearchText] = useState('');
  const [showOwnershipSuggestions, setShowOwnershipSuggestions] = useState(false);

  useEffect(() => {
    setsiteId(match.params.siteId);
    (async () => {
      if (siteId) {
        setIsLoading(true);
        await getContractDataForRenewal(siteId);
        setIsLoading(false);
      }
    })();
  }, [siteId]);

  useEffect(() => {
    if (
      contractData &&
      contractData?.commercials &&
      contractData?.commercials?.postsale_data
    ) {
      setExistingPostsaleData(contractData?.commercials?.postsale_data);
      setProducts(contractData?.products);
      // setCommercialData({ ...commercialData, commercialData: contractData?.commercials?.postsale_data?.commercial });
    }
  }, [contractData]);

  /*useEffect(() => {
    if (renewalSaveResp !== 'undefined') {
      console.log(renewalSaveResp);
    }
  }, [renewalSaveResp]);*/

  const handleAssignee = (val) => {
    setAssigneeData({ ...assigneeData, assigneeDetail: val });
  };
  const handleCommercial = (val) => {
    setPostCorporateData({ ...postCorporateData, commercial: val });
    if (val?.totalContract) {
      setShowAgreementDetails(true);
      setAgreementLength(val?.totalContract);
      setIncrementData({ ...incrementData, increment_type: null, duration: null, increament_amount: null, inc: {
        subscription_amount:val?.subscription_amount,
      } });
      setCommercialData({ ...commercialData, commercialData: { contract_length:val?.totalContract, subscription_amount:val?.subAmt, payment_term_type:val?.paymentTerms, commercial_type_id:val?.commercialType}});
    }
  };
  const handleagreementDtls = (val) => {
    setPostCorporateData({ ...postCorporateData, agreementDtls: val });
  };
  const handleMileStone = (val) => {
    setPostCorporateData({ ...postCorporateData, milestone: val });
  };
  const handleInvoiceAmt = (val) => {
    setPostCorporateData({ ...postCorporateData, invoiceModuleData: val });
  };
  const handleIncreament = (val) => {
    setPostCorporateData({ ...postCorporateData, increamentData: val });
  };

  const handleOwnershipInputChange = (val) => {
    setOwnershipSearchText(val);
    setOwnershipUserId(null);
    setShowOwnershipSuggestions(false);
  };

  const handleOwnershipSearchClick = async () => {
    const query = (ownershipSearchText || '').trim();
    if (!query || query.length < 2) {
      toast.error("Enter at least 2 characters to search");
      setShowOwnershipSuggestions(false);
      return;
    }
    if (!getSearchUser) {
      return;
    }
    setOwnershipUserId(null);
    const res = await getSearchUser(query, { searchEmail: true });
    setShowOwnershipSuggestions(!!res);
  };

  const handleOwnershipSelect = (user) => {
    setOwnershipSearchText(user?.name || '');
    setOwnershipUserId(user?.id || null);
    setShowOwnershipSuggestions(false);
  };

  //console.log(JSON.stringify(postCorporateData));
  const handleSubmit = () => {
    const { commercial, agreementDtls, milestone, invoiceModuleData, increamentData } =
      postCorporateData;
    if (commercial == null || agreementDtls == null) {
      setIsFiled(true);
      // setIsModal(false);
      const active = document.querySelector(".activeAnkInput");
      // console.log(active);
      if (active) {
        active.focus();
      } else {
        alert("Please Upload missed documents !");
      }
      return false;
    } else if (!ownershipUserId) {
      setIsFiled(true);
      toast.error("Please select ownership user");
      return false;
    } else {
      setInvoiceModal(false);
      setIsLoading(true);
      var fObj = {
        ...commercial,
        ...agreementDtls,
        invoiceModuleData
      };
      let increamentDatas = [];
      if(commercial.commercialType == 7){
        if (increamentData !== null && increamentData !== undefined) {
          if (increamentData?.inc?.increament_type) {
            if (increamentData?.inc?.increament_type == 'flat' || increamentData?.inc?.increament_type == 'percentage') {
              if (increamentData?.inc?.duration == undefined || increamentData?.inc?.duration == '' || increamentData?.inc?.increament_amount == undefined ||  increamentData?.inc?.increament_amount == '') {
                toast.error("Please fill the increment Duration and amount")
                return false;
              }
            }
            increamentDatas = increamentData;
          }else{
            toast.error("Please Select increment type")
            return false;
          }
        }
      }
      fObj.increamentDatas = increamentDatas;
      
      if (milestone !== null && milestone != undefined) {
        let calculatedAmt = 0;
        for (
          let i = 0;
          i < postCorporateData.milestone?.date_invoices_data.length;
          i++
        ) {
          if (postCorporateData.milestone.date_invoices_data[i].amt) {
            calculatedAmt += parseInt(
              postCorporateData.milestone.date_invoices_data[i].amt
            );
          }
        }
        // console.log(calculatedAmt);
        if (commercial.totalAmount != calculatedAmt) {
          toast.error("Milestone total amount is not equal to capex amount!");
          setIsLoading(false);
          return;
        } else {
          fObj.milestone = milestone;
        }
      }

      var isStop = false;
      if (invoiceModuleData !== null && invoiceModuleData != undefined) {
        invoiceModuleData.invoiceData.map((val, index) => {
          if (!handleValidateObj(val)) {
            isStop = true;
          }
        });
      }
      if (isStop) {
        toast.error("Please fill all invoice details.");
        setIsLoading(false);
        return false;
      }

      fObj.site_id = match.params.siteId;
      fObj.comm_id = contractData?.commercials?.postsale_data?.commercial?.id;
      fObj.cp_price = contractPriceToEndClient;
      fObj.ownership_user_id = ownershipUserId;
      setIsFiled(false);
      // setIsLoading(true);
      (async () => {
        const res = await renewalSaveData(fObj);
        setIsLoading(false);
        // Only open success when action returns true (API status === 0).
        if (res === true) {
          setIsModal(true);
        }
      })();
    }
  };

  const handleCheckInvoices = async () => {
    const request = {
      billing_start_date: postCorporateData?.commercial?.start_date,
      contract_period: parseInt(postCorporateData?.commercial?.totalContract),
      principal_amount: parseInt(postCorporateData?.commercial?.subAmt),
      payment_cycle: parseInt(postCorporateData?.commercial?.paymentTerms),
    };
    setIsLoading(true);
    setInvoiceModal(true);
    const res = await fetchInvoiceDetails(request);
    if (res) {
      setIsLoading(false);
    }
  };

  const headers = ["Invoice Date", "Amount", "Invoice Terms"];

  useEffect(() => {
    const tableData = ["invoice_date", "amount"];

    if (getInvoiceData !== undefined && getInvoiceData?.length > 0) {
      const data = getInvoiceData.map((element, index) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({
            [key]:
              key === "invoice_date"
                ? new Date(element[key]).toLocaleDateString("en-GB") // Convert format
                : element[key],
          })),
          {
            invoice_terms: `${index + 1}${getOrdinalSuffix(index + 1)} Invoice`,
          }
        )
      );

      data && setListData(data);
    }
  }, [getInvoiceData]);

  // Function to get ordinal suffix (1st, 2nd, 3rd, etc.)
  const getOrdinalSuffix = (num) => {
    if (num > 3 && num < 21) return "th"; // Covers 11th - 20th
    switch (num % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const history = useHistory();

  const handleModalHide = () => setInvoiceModal(false);

  const handleSuccessHide = () => {
    setIsModal(false);
  };

  const headerBtns = () => {
    return (
      <>
        {parseInt(postCorporateData?.commercial?.commercialType) === 16 &&
        parseInt(scheduleType) === 2 ? (
          <Button onClick={handleCheckInvoices} className="btn btn-primary">
            {localization.submitDtl}
            <img src={Images?.ArrowRight} alt="" />
          </Button>
        ) : (
          <Button onClick={handleSubmit} className="btn btn-primary">
            {localization.submitDtl}
            <img src={Images?.ArrowRight} alt="" />
          </Button>
        )}
      </>
    );
  };


  console.log("contractData?.contractData?.postsale_data?.commercial?.channel_partner_id: ", contractData?.commercials?.postsale_data?.commercial?.channel_partner_id)

  return (
    <Layout
      title={localization.renewContract}
      Buttons={headerBtns}
      className={isFiled ? "requiredFileds" : ""}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/brand-activation/sites-listing`}
    >
      {/*<Fragment>
        <FormSection title={localization.commercialType}>
          <DropDownInput
              data={commercialTypes}
              label={localization.commercialType}
              required
              isStarRequired={true}
              errorMsg={localization.requiredcommercialType}
              getIdValue={(val) => handleIdvalue(val)}
              value={commercialData.commercialPrefilled.value}
              disabled = {edit == 1 ?true:false}
          />
        </FormSection>
      </Fragment>*/}
      {/*<Assignee
        assigneeList={assigneeList}
        siteId={siteId}
        handleValue={handleAssignee}
        isBulkAssignment={true}
        baAssignee={true}
      />*/}
      {contractData && (
        <>
          <Fragment>
            <div className="panel-card">
              <div className="panel-heading">
                {localization.existingContract}
              </div>
              <div className="panel-body">
                <div className="details-listing detail_alignment">
                  <DivLayout
                    heading={localization.siteName}
                    data={
                      contractData?.commercials &&
                      contractData?.commercials?.lead_data &&
                      contractData?.commercials?.lead_data?.client_name
                        ? contractData?.commercials?.lead_data?.client_name
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.contractType}
                    data={
                      existingPostsaleData &&
                      existingPostsaleData?.commercial &&
                      existingPostsaleData?.commercial?.commercialName
                        ? existingPostsaleData?.commercial?.commercialName
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.totalAmount}
                    data={
                      existingPostsaleData &&
                      existingPostsaleData?.commercial &&
                      (existingPostsaleData?.commercial?.commercialName ==
                        "Capex" ||
                        existingPostsaleData?.commercial?.commercialName ==
                          "MDR")
                        ? existingPostsaleData?.commercial?.total_mg_amount
                        : existingPostsaleData?.commercial?.subscription_amount
                    }
                  />
                  <DivLayout
                    heading={localization.paymentTerms}
                    data={
                      existingPostsaleData &&
                      existingPostsaleData?.commercial &&
                      existingPostsaleData?.commercial?.payment_term_type
                        ? existingPostsaleData?.commercial?.payment_term_type
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.paymentModes}
                    data={
                      existingPostsaleData &&
                      existingPostsaleData?.commercial &&
                      existingPostsaleData?.commercial?.payment_mode
                        ? existingPostsaleData?.commercial?.payment_mode
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.totalContract}
                    data={
                      existingPostsaleData &&
                      existingPostsaleData?.commercial &&
                      existingPostsaleData?.commercial?.contract_length
                        ? existingPostsaleData?.commercial?.contract_length
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.LockIn}
                    data={
                      existingPostsaleData &&
                      existingPostsaleData?.commercial &&
                      existingPostsaleData?.commercial?.contract_lockin_period
                        ? existingPostsaleData?.commercial
                            ?.contract_lockin_period
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.agreementContractPeriodFrom}
                    data={
                      contractData &&
                      contractData?.recon_data &&
                      contractData?.recon_data?.actual_start_date
                        ? contractData?.recon_data?.actual_start_date
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.agreementContractPeriodTo}
                    data={
                      contractData &&
                      contractData?.recon_data &&
                      contractData?.recon_data?.actual_end_data
                        ? contractData?.recon_data?.actual_end_data
                        : localization.na
                    }
                  />
                </div>
              </div>
            </div>
          </Fragment>

          <FormSection title={"Ownership User"}>
            <div className="col-md-12">
              <div className="d-flex align-items-end" style={{ gap: "8px" }}>
                <div style={{ flex: 1 }}>
                  <ConstantInput
                    fullWidth
                    label={"Search ownership user by name or email"}
                    value={ownershipSearchText}
                    type="text"
                    required
                    isStarRequired={true}
                    errorMsg={"Ownership user is required"}
                    handleChange={handleOwnershipInputChange}
                  />
                </div>
                <Button
                  type="button"
                  className="btn btn-outline-primary btn-primary colorBox borderColorBox mb-3"
                  onClick={handleOwnershipSearchClick}
                >
                  Search
                </Button>
              </div>
              {showOwnershipSuggestions && (
                <div className="form-group full-width">
                  <ul className="suggestion-list scrollbar-styling">
                    {Array.isArray(ownershipUserSuggestions) &&
                    ownershipUserSuggestions.length > 0 ? (
                      ownershipUserSuggestions.map((user, ind) => (
                        <li key={user?.id || ind} onClick={() => handleOwnershipSelect(user)}>
                          {user.name}
                        </li>
                      ))
                    ) : (
                      <li>{localization.noRecord || "No record found"}</li>
                    )}
                  </ul>
                </div>
              )}
            </div>
          </FormSection>

          <Commercial
            data={contractData}
            handleValue={handleCommercial}
            documentUploadUrl={documentUploadUrl}
            documentUrlData={documentUrlData}
            isRenewal={true}
            setScheduleType={setScheduleType}
          />
          {(contractData && contractData?.commercials && contractData?.commercials?.postsale_data && contractData?.commercials?.postsale_data?.commercial && contractData?.commercials?.postsale_data?.commercial?.channel_partner_id && contractData?.commercials?.postsale_data?.commercial?.channel_partner_id !== null) && (
            <>
            <FormSection title={"Contract Price to end client"}>
            <div className="col-md-12">
              <ConstantInput
                  label={'Contract Price to end client'}
                  required
                  isStarRequired={true}
                  errorMsg={'Contract Price to end client is required'}
                  type="number"
                  handleChange={(val) =>
                      setContractPriceToEndClient(val)
                  }
              />
            </div>
          </FormSection>
            </>
          )}

          {(contractData.commericals?.postsale_data?.commercial?.revenue_nature !== 'Valet' || contractData.commericals?.postsale_data?.commercial?.revenue_nature !== 'Services') && (postCorporateData.commercial?.commercialType === 7 || postCorporateData.commercial?.commercialType === 6) &&
           <>
           <Increament
                handleValue={handleIncreament}
                data={commercialData}
                // imageUploadUrl={imageUploadUrl}
                prefilledData={incrementData}
              />
              
            </>
          }
          <AgreementContract
            handleValue={handleagreementDtls}
            documentUploadUrl={documentUploadUrl}
            agreementLength={agreementLength}
            showDetails={showAgreementDetails}
          />
          {postCorporateData.commercial?.commercialType === 5 && (
            <Milestone handleValue={handleMileStone} isRenewal={true} />
          )}
          {postCorporateData.commercial?.commercialType === 7 && (
            <InvoiceModuleRenew
              handleValue={handleInvoiceAmt}
              data={postDataInputs}
              prefilledData={postDataInputs?.postsale_data}
              invoiceAmtData={postDataInputs?.postsale_data}
              isdisable={false}
              productData={products}
            />
          )}
        </>
      )}

      <ModalPop title={localization.conf} show={isModal}>
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.preB2bSuccess}</h5>
          <Link
            to={`${baseUrl}/brand-activation/sites-listing`}
            className="btn btn-primary mb-4"
            onClick={handleSuccessHide}
          >
            {localization.continue} <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
      <ModalPop
        title={"Check Invoices"}
        show={invoiceModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="col-md-12">
          <TableSection data={listData} isId={true} headers={headers} />
        </div>
        {!confirmInvoices && (
          <>
            <div className="mt-5">
              <h5 style={{ fontWeight: "bold" }}>
                <span style={{ color: "red" }}>*</span>Please check your invoice
                details first and confirm
              </h5>
            </div>
            <div className="d-flex" style={{ justifyContent: "space-between" }}>
              <Button
                className="btn btn-danger btn-sm"
                onClick={handleModalHide}
              >
                Close
              </Button>
              <Button className="btn btn-success btn-sm" onClick={handleSubmit}>
                Confirm
              </Button>
            </div>
          </>
        )}
      </ModalPop>
    </Layout>
  );
};

RenewContract.propTypes = {};

export default RenewContract;
